// Shared style for table action icon buttons.
// Pass an MUI color key ("primary" | "tertiary" | "error" | etc.) for the hover tint.
export const actionBtnSx = (color = "primary") => (theme) => {
  const main =
    theme.palette[color]?.main || theme.palette.primary.main;
  return {
    width: 32,
    height: 32,
    borderRadius: 1,
    border: "1px solid",
    borderColor: theme.palette.divider,
    color: theme.palette.text.secondary,
    transition: "all 0.15s ease-in-out",
    mx: 0.25,
    "&:hover": {
      color: main,
      borderColor: main,
      backgroundColor: `${main}14`,
    },
    "&.Mui-disabled": {
      borderColor: theme.palette.divider,
      backgroundColor: "transparent",
    },
  };
};
